import React from 'react';
import { useRouter } from 'next/router';

import { FETCH_STATUSES } from '@tager/web-core';

import { useTypedSelector } from '@/store/store';
import { selectPostResource } from '@/store/reducers/pages/post';
import { getAliasWithoutId, getParamAsString } from '@/utils/common';
import NotFoundPage from '@/pages/404';

import PostPage from './components/PostPage';
import PlaceholderPagePost from './components/PlaceholderForPost';

function Post() {
  const router = useRouter();

  const alias = getParamAsString(router.query.alias);
  const postResource = useTypedSelector((state) =>
    selectPostResource(state, getAliasWithoutId(alias))
  );

  if (!postResource) return <NotFoundPage />;

  if (postResource.status === FETCH_STATUSES.LOADING) {
    return <PlaceholderPagePost />;
  }

  if (postResource.data) {
    return <PostPage post={postResource.data} />;
  }

  return null;
}

export default Post;
